import {IMedication} from "../../../../../../../utils/interfaces";

export const times = [
  '23:00',
  '22:00',
  '21:00',
  '20:00',
  '19:00',
  '18:00',
  '17:00',
  '16:00',
  '15:00',
  '14:00',
  '13:00',
  '12:00',
  '11:00',
  '10:00',
  '09:00',
  '08:00',
  '07:00',
  '06:00',
  '05:00',
  '04:00',
  '03:00',
  '02:00',
  '01:00',
  '00:00',
] as const;

export type Time = typeof times[number];

export type MedicationsTableProps = {
  onEditMedication: (medication: IMedication) => void;
  onRemoveMedication: (medication: IMedication) => void;
    period: DatesPeriodType;
}

export type DatesPeriodType = null | {start: Date, end: Date, interval: Date[]};
